import { render, staticRenderFns } from "./SoundEffectTab.vue?vue&type=template&id=550cc176"
import script from "./SoundEffectTab.vue?vue&type=script&lang=js"
export * from "./SoundEffectTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports